<main class="bg-container app" *ngIf="loaderTranslator; else available">
  <del-shared-header
    [ngClass]="!isNotSsoPage ? 'd-none' : ''"
    [ngClass]="router.url === '/chat/home' ? 'd-lg-block' : ''"
    [ngClass]="router.url === '/chat/chat-messages' ? 'd-none' : ''"
  ></del-shared-header>

  <router-outlet></router-outlet>

  <div class="d-md-none py-4"></div>
  <!--MOBILE MENU-->
  <ng-container *ngIf="isNotSsoPage">
    <nk-shared-menu-mobile
      [class.d-none]="
        router.url === '/homepage' ||
        router.url === '/register'  ||
        router.url === '/chat/chat-messages' 
      "
    ></nk-shared-menu-mobile>

    <nk-shared-chat-list-box
      *ngIf="
        router.url !== '/chat/home' &&
        router.url !== '/chat/chat-call' &&
        router.url !== '/chat/chat-messages'
      "
    ></nk-shared-chat-list-box>
  </ng-container>
</main>

<ng-template #available>  <del-shared-loading-app></del-shared-loading-app>  </ng-template>
